import React from 'react'
import { CardModal, Type } from '@/components/common'
import { Campaign } from '@/services/api/campaign'
import StretchGoalModalListItem from './StretchGoalsModalListItem'

export interface Props {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  campaign: Campaign
}

const StretchGoalsModal: React.FC<Props> = ({
  isOpen,
  setIsOpen,
  campaign,
}) => {
  const { stretchGoal, stretchGoals, name } = campaign

  // If no stretch goal, then there are no incomplete goals,
  // so set current goal index to stretch goals length so all goals
  // appear in the completed list
  const currentGoalIdx = stretchGoal
    ? stretchGoals.findIndex((g) => g.amount === stretchGoal.amount)
    : stretchGoals.length

  const upNext = stretchGoals.slice(currentGoalIdx)
  const completed = stretchGoals.slice(0, currentGoalIdx)

  return (
    <CardModal isOpen={isOpen} setIsOpen={setIsOpen}>
      <div className="max-w-full bg-core-gray-100 px-5 py-6 sm:px-6 sm:pb-6 md:w-[500px]">
        <CardModal.Title className="mb-4 pr-12">
          <Type as="span" variant="title-sm" className="font-semibold">
            {name} Goals
          </Type>
        </CardModal.Title>

        {upNext.length > 0 && (
          <div className="mt-6">
            <Type
              as="h3"
              variant="title-xs"
              className="mb-2 font-bold text-core-gray-700"
            >
              Up Next
            </Type>
            <ul className="overflow-hidden rounded-lg border border-gray-8">
              {upNext.map(({ title, amount, description }, idx) => (
                <StretchGoalModalListItem
                  key={amount}
                  idx={currentGoalIdx + idx + 1}
                  title={title}
                  amount={amount}
                  description={description}
                  status={idx === 0 ? 'in-progress' : 'default'}
                />
              ))}
            </ul>
          </div>
        )}

        {completed.length > 0 && (
          <div className="mt-6">
            <Type
              as="h3"
              variant="title-xs"
              className="mb-2 font-bold text-core-gray-700"
            >
              Completed Goals
            </Type>
            <ul className="overflow-hidden rounded-lg border border-gray-8">
              {completed.map(({ title, amount, description }, idx) => (
                <StretchGoalModalListItem
                  key={amount}
                  idx={idx + 1}
                  title={title}
                  amount={amount}
                  description={description}
                  status="complete"
                />
              ))}
            </ul>
          </div>
        )}
      </div>
    </CardModal>
  )
}

export default StretchGoalsModal
